import { useCallback, useRef } from 'react';
import type { CallerProvidedTagsT, FrameDecodeTagsT, PerformanceMetricActionT } from '../../analytics/types/performance';
import { usePerformanceMetrics } from './use-performance-metrics';
const isPerformanceTimingAvailable = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.measure === 'function';
type CompleteFn = (tags?: CallerProvidedTagsT | FrameDecodeTagsT) => void;

// For async operations (worker round-trips). Returns a complete() function.
export function useMeasureLatency() {
  const {
    captureLatency
  } = usePerformanceMetrics();
  const captureLatencyRef = useRef(captureLatency);
  captureLatencyRef.current = captureLatency;
  return useCallback((metricName: PerformanceMetricActionT): CompleteFn => {
    if (!isPerformanceTimingAvailable) {
      return () => {};
    }
    const markName = metricName + '_start';
    performance.mark(markName);
    return (tags?) => {
      try {
        const measure = performance.measure(metricName, markName);
        captureLatencyRef.current({
          name: metricName,
          durationMs: measure.duration,
          tags
        });
      } catch {} finally {
        performance.clearMarks(markName);
        performance.clearMeasures(metricName);
      }
    };
  }, []);
}